import { createFileRoute, useRouter } from '@tanstack/react-router';
import { useCallback } from 'react';

import { GamePlayer } from '~/components/game/GamePlayer';
import { requireAuth } from '~/lib/route-guards';
import type { PublicLandingPage } from '~/types';

export const Route = createFileRoute('/$slug/game/$episodeId')({
  beforeLoad: ({ context }: { context: Record<string, any> }) => {
    requireAuth(context.slug as string);
  },
  component: GamePage,
});

function GamePage() {
  const router = useRouter();
  const { slug, landingPage } = Route.useRouteContext() as {
    slug: string;
    landingPage: PublicLandingPage;
  };
  const { episodeId } = Route.useParams();

  const handleGameComplete = useCallback(
    (scoreData?: { score: number; totalQuestions: number }) => {
      if (scoreData) {
        router.navigate({
          to: '/$slug/score',
          params: { slug },
          search: {
            score: scoreData.score,
            totalQuestions: scoreData.totalQuestions,
            pointsPerCorrectAnswer: landingPage.gameOptions.pointsPerCorrectAnswer,
          },
        });
      } else {
        router.navigate({
          to: '/$slug/offer',
          params: { slug },
        });
      }
    },
    [router, slug, landingPage.gameOptions.pointsPerCorrectAnswer],
  );

  return (
    <div className="h-screen w-screen overflow-hidden">
      <GamePlayer
        slug={slug}
        episodeId={episodeId}
        gameOptions={landingPage.gameOptions}
        onGameComplete={handleGameComplete}
        className="h-full w-full"
      />
    </div>
  );
}
